function y(r) {
  return new p(r);
}
function w(r) {
  return new g(r);
}
let x = 0;
class p {
  constructor(t) {
    this._eval = "", this._lookups = /* @__PURE__ */ new Map(), this._sorts = [], this._limit = 1 / 0, this._offset = 0, this._isEqual = f, t && (this._expression = new u(t));
  }
  on(t) {
    if (typeof t.then == "function")
      return t.then((n) => this.on(n));
    let e = t;
    const s = this._getFilter(), i = this._getSort();
    return s ? e = e.filter(s, y) : e = e.slice(), Array.isArray(e) ? (i && e.sort(i), (this._offset || this._limit !== 1 / 0) && (e = e.slice(this._offset, this._offset + this._limit)), e) : [e];
  }
  first(t) {
    return typeof t.then == "function" ? t.then((e) => this.first(e)) : this.on(t)[0];
  }
  last(t) {
    if (typeof t.then == "function")
      return t.then((s) => this.last(s));
    const e = this.on(t);
    return e[e.length - 1];
  }
  /**
   * Ands two expressions or queries.
   */
  and(t) {
    return this._term("&&", t);
  }
  /**
   * Ors two expressions or queries.
   */
  or(t) {
    return this._term("||", t);
  }
  /**
   * Checks if the value is not equal to the given value.
   */
  not(t) {
    return this._expression && (this._expression.not = !this._expression.not, t !== void 0 && (this._expression.value = t)), this;
  }
  /**
   * Checks if the value is equal to the given value.
   */
  equals(t) {
    return this._oper("===", t);
  }
  /**
   * Checks if the value is equal to the given value. Alias if `equals`.
   */
  is(t) {
    return this.equals(t);
  }
  /**
   * Checks if the value is equal to the given value. Alias if `equals`.
   */
  isNaN(t) {
    return this._expression && (this._expression.template = "%not%operator(%term)"), this._oper("isNaN", t);
  }
  /**
   * Checks if the value is not equal to the given value.
   */
  isnt(t) {
    return this.is(t).not();
  }
  /**
   * Checks if the value is in the given array or Set.
   */
  within(t) {
    return t instanceof Set || (t = new Set(t)), this._expression && (this._expression.template = "%not%operator.has(%term)"), this._oper(this._store(t));
  }
  /**
   * Checks if the array value has the given value.
   */
  has(t) {
    return this._expression && (this._expression.template = "%not(%term && %term.includes?.(%value))"), this._oper("", t);
  }
  /**
   * Checks if the array value has all the given values.
   */
  hasAll(t) {
    return this._expression && (this._expression.template = "%not(%term && %value?.every(item => %term.includes?.(item)))"), this._oper("", t);
  }
  /**
   * Checks if the value starts with the given value.
   */
  startsWith(t) {
    return this._expression && (this._expression.template = "%not(%term != null && %term.startsWith(%value))"), this._oper("", t);
  }
  /**
   * Checks if the value ends with the given value.
   */
  endsWith(t) {
    return this._expression && (this._expression.template = "%not(%term != null && %term.endsWith(%term.length - %value))"), this._oper("", t);
  }
  /**
   * Checks if the value is greater than the given value.
   */
  gt(t) {
    return this._oper(">", t);
  }
  /**
   * Checks if the value is greater than or equal to the given value.
   */
  gte(t) {
    return this._oper(">=", t);
  }
  /**
   * Checks if the value is less than the given value.
   */
  lt(t) {
    return this._oper("<", t);
  }
  /**
   * Checks if the value is less than or equal to the given value.
   */
  lte(t) {
    return this._oper("<=", t);
  }
  /**
   * Tests if the value matches with the given regular expression.
   */
  test(t) {
    return this._expression && (this._expression.template = "%not(%term != null && %operator.test(%term))"), this._oper(this._store(t));
  }
  /**
   * Alias for `test`.
   */
  regex(t) {
    return this.test(t);
  }
  /**
   * Checks if the value is equivalent to the given value using `isEqual`.
   */
  same(t, e) {
    return this._expression && (this._expression.template = "%not(this._isEqual(%term, %value, %operator))"), this._oper(this._store(e), t);
  }
  /**
   * Filters by the given filter function.
   */
  filter(t) {
    if (typeof t != "function")
      throw new Error("query.filter() parameter must be a function");
    return this._expression ? this._expression.template = "%not(%operator(%term))" : (this._expression = new u(), this._expression.template = "%not(%operator(obj))"), this._oper(this._store(t));
  }
  /**
   * Checks if any of the whole words are present in the given field.
   */
  search(t) {
    t = d(t);
    var e = new RegExp("\\b" + t.split(/\s/).join("|\\b"));
    return this.test(e);
  }
  /**
   * Checks if the value is of the given type or instance
   */
  type(t) {
    return typeof t == "function" ? (this._expression ? this._expression.template = "%not(%term instanceof %operator)" : (this._expression = new u(), this._expression.template = "%not(obj instanceof %operator)"), this._oper(this._store(t))) : typeof t == "string" ? (this._expression && (this._expression.template = "%not(typeof %term %operator %value)"), this._oper("==", t)) : this;
  }
  /**
   * Sorts the results by the given field.
   */
  sortOn(t) {
    return this.sort(t);
  }
  /**
   * Sorts the results by the given field. Alias of `sortOn` but `field` is not required.
   */
  sort(t) {
    return this._sortCache && (this._sortCache = void 0), this._sorts.push(new c(t)), this;
  }
  /**
   * Sort the results in ascending order.
   */
  asc() {
    return this._sortDir(1);
  }
  /**
   * Sort the results in descending order.
   */
  desc() {
    return this._sortDir(-1);
  }
  /**
   * Sort the results using the given function.
   */
  custom(t) {
    return this._sortType(t);
  }
  limit(t) {
    return this._limit = t, this;
  }
  offset(t) {
    return this._offset = t, this;
  }
  toString() {
    return this._flush(), this._eval;
  }
  _getFilter() {
    let t = this.toString();
    return t ? (this._filterCache || (this._filterCache = new Function(
      "obj",
      "try { return " + t + "; } catch (e) { return false; }"
    ).bind(this)), this._filterCache) : null;
  }
  _getSort() {
    if (!this._sorts.length)
      return null;
    if (!this._sortCache) {
      var t = this._sorts.map((e) => e.toFunction());
      this._sortCache = (e, s) => {
        let i = 0, n = 0, o = t.length;
        for (; n < o && i === 0; )
          i = t[n++](e, s);
        return i;
      };
    }
    return this._sortCache;
  }
  _term(t, e) {
    if (this._flush(), this._eval += " " + t + " ", typeof e == "string")
      this._expression = new u(e);
    else if (e !== void 0) {
      if (e instanceof p)
        for (const [s, i] of e._lookups)
          this._lookups.set(s, i);
      this._eval += "(" + e + ")";
    }
    return this;
  }
  _oper(t, e) {
    return this._expression && (this._expression.operator = t, this._expression.value = e), this;
  }
  _store(t) {
    return this._lookups.set(++x, t), `this._lookups.get(${x})`;
  }
  _sortDir(t) {
    if (this._sorts.length !== 0)
      return this._sortCache && (this._sortCache = void 0), this._sorts[this._sorts.length - 1].direction = t, this;
  }
  _sortType(t) {
    if (this._sorts.length === 0)
      return;
    this._sortCache && (this._sortCache = void 0);
    const e = this._sorts[this._sorts.length - 1];
    return e.type = t, this;
  }
  _flush() {
    this._expression && (this._eval += this._expression, this._expression = void 0, this._filterCache = void 0);
  }
}
class g extends p {
  constructor(t) {
    super(""), this.array = t;
  }
  where(t) {
    this._expression = new u(t);
  }
  end() {
    return this.on(this.array);
  }
}
class u {
  constructor(t) {
    this.term = t, this.operator = "", this.not = !1, this.template = "%not(%term %operator %value)";
  }
  toString() {
    return this.template.replace(/%\w+/g, (t) => {
      if (t === "%not")
        return this.not ? "!" : "";
      if (t === "%term") {
        if (!this.term)
          throw new Error('Missing "field" in query');
        return `(obj?.${this.term.replace(
          /(?:\.|(\[))/g,
          "?.$1"
        )} ?? obj?.get?.("${this.term}"))`;
      }
      return t === "%operator" ? this.operator : t === "%value" ? JSON.stringify(
        this.value instanceof Date ? this.value.getTime() : this.value
      ) : "";
    });
  }
}
class c {
  constructor(t) {
    this.term = t, this.type = c.regular, this.direction = 1;
  }
  static regular(t, e) {
    return e == null || a(e) ? t == null || a(t) ? (t = t === void 0 ? 2 : t === null ? 1 : 0, e = e === void 0 ? 2 : e === null ? 1 : 0, t > e ? 1 : t < e ? -1 : 0) : -1 : t == null || a(e) || t > e ? 1 : t < e ? -1 : 0;
  }
  toFunction() {
    const { term: t, direction: e, type: s } = this;
    let i = s;
    return t ? i = (n, o) => e * s(n[t], o[t]) : e !== 1 && (i = (n, o) => e * s(n, o)), i;
  }
}
function d(r) {
  return r.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
function f(r, t, e) {
  if (r === t)
    return !0;
  const s = typeof r, i = typeof r;
  if (s === "number" && i === "number" && isNaN(r) && isNaN(t))
    return !0;
  if (!r || !t || s !== "object" || i !== "object" || r.constructor !== t.constructor)
    return !1;
  if (r.valueOf() !== r)
    return f(r.valueOf(), t.valueOf(), e);
  if (typeof r[Symbol.iterator] == "function") {
    const h = r[Symbol.iterator](), m = t[Symbol.iterator]();
    let l = h.next(), _ = m.next();
    for (; !l.done && !_.done; ) {
      if (!f(l.value, _.value, e))
        return !1;
      l = h.next(), _ = m.next();
    }
    return l.done === _.done;
  }
  const n = Object.keys(r), o = Object.keys(t);
  return ((e == null ? void 0 : e.partial) || n.length === o.length) && o.every(
    (h) => r.hasOwnProperty(h) && f(t[h], r[h], e)
  );
}
function a(r) {
  return typeof r == "number" && isNaN(r);
}
export {
  p as Query,
  g as Select,
  y as query,
  w as select
};
